import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.125 0.020c-6.89 0.514-12.237 6.581-12.237 13.573v9.769c0 2.468 1.954 4.319 4.319 4.319h1.44c1.645 0 2.879-1.337 2.879-2.879v-5.861c0-1.645-1.337-2.879-2.879-2.879h-2.776v-2.468c0-5.553 4.319-10.489 9.872-10.591 5.758-0.206 10.489 4.422 10.489 10.18v2.879h-2.879c-1.645 0-2.879 1.337-2.879 2.879v5.861c0 1.645 1.337 2.879 2.879 2.879h2.879v1.44h-8.741c-0.823 0-1.44 0.617-1.44 1.44s0.617 1.44 1.44 1.44h7.301c2.468 0 4.319-1.954 4.319-4.319v-14.499c0.103-7.609-6.273-13.573-13.985-13.162z" })
});
export default SvgSupport;
